export default {
  accessToken: localStorage.getItem('access_token') || null,
  currentUser: null
}
